var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.72916 11.2812C6.72916 12.8012 7.97999 14.0521 9.49999 14.0521C11.02 14.0521 12.2708 12.8012 12.2708 11.2812",
    stroke: "#00a14b",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9746 1.58333L4.10876 4.45708",
    stroke: "#00a14b",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0254 1.58333L14.8913 4.45708",
    stroke: "#00a14b",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58334 6.21459C1.58334 4.75001 2.36709 4.63126 3.34084 4.63126H15.6592C16.6329 4.63126 17.4167 4.75001 17.4167 6.21459C17.4167 7.91667 16.6329 7.79792 15.6592 7.79792H3.34084C2.36709 7.79792 1.58334 7.91667 1.58334 6.21459Z",
    stroke: "#00a14b",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77084 7.91667L3.88709 14.7567C4.14043 16.2925 4.75001 17.4167 7.01418 17.4167H11.7879C14.25 17.4167 14.6142 16.34 14.8992 14.8517L16.2292 7.91667",
    stroke: "#00a14b",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.a42b3bd0528e2f12b5783fc7ea0c1e08.svg";
export { ForwardRef as ReactComponent };